import { FileFilterKey, FileFilterModel } from '../domain';
import { useFilter } from '../../filter';

export const useFileFilter = () => {
  return useFilter(
    FileFilterKey,
    'fileFilter',
    (filter: any) => new FileFilterModel(filter),
    true
  );
};
